@if (item) {
  <div class="container">
    <coin-color-picker [(ngModel)]="item.backgroundColor"></coin-color-picker>
    <coin-color-picker
      [isTextColorPicker]="true"
      [(ngModel)]="item.textColor"></coin-color-picker>
    <coin-email-slider
      label="Space-Top"
      [(ngModel)]="item.paddingTop"></coin-email-slider>
    <coin-email-slider
      label="Space-Bottom"
      [(ngModel)]="item.paddingBottom"></coin-email-slider>
    <coin-v2-checkbox
      [label]="'cms.emails.auto-sync-index-list' | translate"
      [(ngModel)]="automaticSyncEnabled"
      (ngModelChange)="confirmAutoSync()" />
    <div
      class="index-list"
      cdkDropList
      (cdkDropListDropped)="drop($event)">
      @for (index of item.content; track trackByIndexItemFn(i, index); let i = $index) {
        <div
          class="index"
          cdkDrag
          cdkDragBoundary=".index-list">
          <div class="reference-title">
            <mat-icon
              class="drag"
              cdkDragHandle
              [class.disabled]="item.automaticSyncEnabled">
              drag_indicator
            </mat-icon>
            <mat-label>{{ index.referenceTitle }}</mat-label>
          </div>
          <div class="editor">
            <editor
              licenseKey="gpl"
              [init]="tinyMceIndexListQuillConfig"
              [(ngModel)]="index.title"></editor>
          </div>
          <div class="delete">
            <mat-icon
              class="delete"
              [class.disabled]="item.automaticSyncEnabled"
              (click)="deleteItem(index)">
              delete
            </mat-icon>
          </div>
        </div>
      }
    </div>

    <div class="buttons">
      <coin-v2-button
        type="primary"
        [disabled]="item.automaticSyncEnabled"
        [text]="'cms.emails.add-index-item' | translate"
        (click)="addItem()"></coin-v2-button>
    </div>
  </div>
}
